import { useNavigate, useParams } from "react-router";
import { useSamplesWaterBaseDataShowQuery } from "@/services/backend/samples/api/water-base-data-api";
import { WaterBaseDataFields } from "@/services/backend/samples/components/water-base-data-fields";
import { DeleteWaterBaseDataDialog } from "@/services/backend/samples/components/delete-water-base-data-dialog";
import { SampleBaseDataDetailCard } from "@/routes/base-data/samples/_components/sample-base-data-detail-card";
import { PersistenceContextProvider } from "@/shared/lib/persistence-state/provider";

export function WaterBaseDataRoute() {
  const { baseDataId } = useParams();
  const navigate = useNavigate();

  const {
    data: baseData,
    isLoading,
    error,
  } = useSamplesWaterBaseDataShowQuery({ id: baseDataId! });

  return (
    <PersistenceContextProvider>
      <SampleBaseDataDetailCard
        baseData={baseData}
        isLoading={isLoading}
        error={error}
        actions={
          baseData && (
            <DeleteWaterBaseDataDialog
              baseData={baseData}
              onDeleted={() => navigate("..")}
            />
          )
        }
      >
        {baseData && <WaterBaseDataFields id={baseData.id} />}
      </SampleBaseDataDetailCard>
    </PersistenceContextProvider>
  );
}
